// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../components/Form.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function fromInt(y) {
  return /* YearTh */{
          _0: y
        };
}

function fromString(y) {
  return /* YearTh */{
          _0: Belt_Option.getExn(Belt_Int.fromString(y))
        };
}

function toInt(y) {
  return y._0;
}

var YearTh = {
  fromInt: fromInt,
  fromString: fromString,
  toInt: toInt
};

function fromInt$1(y) {
  return /* YearUs */{
          _0: y
        };
}

function toInt$1(y) {
  return y._0;
}

function fromYearTh(y) {
  var x = y._0;
  return /* YearUs */{
          _0: x - 543 | 0
        };
}

function toYearTh(y) {
  var x = y._0;
  return /* YearTh */{
          _0: x + 543 | 0
        };
}

var YearUs = {
  fromInt: fromInt$1,
  toInt: toInt$1,
  fromYearTh: fromYearTh,
  toYearTh: toYearTh
};

var now = new Date(Date.now());

var current_us_year = now.getFullYear() | 0;

var current_month = (now.getMonth() | 0) + 1 | 0;

var yearOptions = Belt_Array.range(2464, current_us_year + 543 | 0).map(function (x) {
      return {
              value: String(x),
              label: String(x)
            };
    });

var thmonth = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม"
];

function getMonthOptions(max_month) {
  return Belt_Array.range(1, max_month).map(function (x) {
              return {
                      value: String(x),
                      label: Belt_Option.getWithDefault(Belt_Array.get(thmonth, x - 1 | 0), "")
                    };
            });
}

function daysInMonth(month, year) {
  var d = new Date(year, month, 0.0);
  return d.getDate() | 0;
}

function getMaxDay(month, year) {
  var year$1 = year._0;
  return daysInMonth(month, year$1);
}

function getDaysOfMonth(month, year) {
  var max_day = getMaxDay(month, year);
  return Belt_Array.range(1, max_day);
}

function getDayOptions(month, year) {
  return getDaysOfMonth(month, year).map(function (x) {
              return {
                      value: String(x),
                      label: String(x)
                    };
            });
}

function fromISODateString(text) {
  var d = text.split("-");
  return {
          day: Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Array.get(d, 2), Belt_Int.fromString), 1),
          month: Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Array.get(d, 1), Belt_Int.fromString), 1),
          year: /* YearUs */{
            _0: Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Array.get(d, 0), Belt_Int.fromString), 1987)
          }
        };
}

function toISODateString(d) {
  var year = d.year._0;
  var month = d.month - 1 | 0;
  var day = d.day;
  var x = new Date(Date.UTC(year, month, day)).toISOString().split("T");
  return Belt_Option.getWithDefault(Belt_Array.get(x, 0), "");
}

function ProfileBirthdate(Props) {
  var birthdate = Props.birthdate;
  var onChangeDay = Props.onChangeDay;
  var onChangeMonth = Props.onChangeMonth;
  var onChangeYear = Props.onChangeYear;
  var disabledOpt = Props.disabled;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var year = birthdate.year;
  var month = birthdate.month;
  var day = birthdate.day;
  var match = React.useState(function () {
        return getMonthOptions(12);
      });
  var setMonths = match[1];
  var months = match[0];
  var match$1 = React.useState(function () {
        return getDayOptions(month, year);
      });
  var setDays = match$1[1];
  var days = match$1[0];
  React.useEffect((function () {
          Curry._1(setDays, (function (param) {
                  return getDayOptions(month, year);
                }));
          
        }), [
        month,
        year
      ]);
  var adjustment_day = function (new_month, year) {
    var max_day = getMaxDay(Belt_Option.getExn(Belt_Int.fromString(new_month)), year);
    if (day > max_day) {
      return Curry._1(onChangeDay, 1);
    }
    
  };
  var handleOnChangeMonth = function (new_month) {
    Curry._1(onChangeMonth, Belt_Option.getExn(Belt_Int.fromString(new_month)));
    Curry._1(setDays, (function (param) {
            return getDayOptions(Belt_Option.getExn(Belt_Int.fromString(new_month)), year);
          }));
    return adjustment_day(new_month, year);
  };
  var handleOnChangeYear = function (new_year) {
    var new_year_th = fromYearTh(/* YearTh */{
          _0: Belt_Option.getExn(Belt_Int.fromString(new_year))
        });
    Curry._1(onChangeYear, new_year_th);
    if (new_year_th._0 !== current_us_year) {
      return Curry._1(setMonths, (function (param) {
                    return getMonthOptions(12);
                  }));
    }
    var opts = getMonthOptions(current_month);
    Curry._1(setMonths, (function (param) {
            return opts;
          }));
    Curry._1(onChangeMonth, current_month);
    return adjustment_day(String(current_month), new_year_th);
  };
  return React.createElement(React.Fragment, undefined, React.createElement(Form.Label.make, {
                  text: "วันเกิด"
                }), React.createElement("div", {
                  className: "flex justify-between space-x-1"
                }, React.createElement("div", {
                      className: "w-3/12"
                    }, disabled ? React.createElement(Form.LabelLock.make, {
                            label: Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.getBy(days, (function (x) {
                                            return x.value === String(day);
                                          })), (function (x) {
                                        return x.label;
                                      })), "-")
                          }) : React.createElement(Form.Select.make, {
                            data: days,
                            value: String(day),
                            onChange: (function (param) {
                                return Curry._1(onChangeDay, Belt_Option.getExn(Belt_Int.fromString(param)));
                              }),
                            disabled: disabled
                          })), React.createElement("div", {
                      className: "w-5/12"
                    }, disabled ? React.createElement(Form.LabelLock.make, {
                            label: Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.getBy(months, (function (x) {
                                            return x.value === String(month);
                                          })), (function (x) {
                                        return x.label;
                                      })), "-")
                          }) : React.createElement(Form.Select.make, {
                            data: months,
                            value: String(month),
                            onChange: handleOnChangeMonth,
                            disabled: disabled
                          })), React.createElement("div", {
                      className: "w-4/12"
                    }, disabled ? React.createElement(Form.LabelLock.make, {
                            label: Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.getBy(yearOptions, (function (x) {
                                            return x.value === String(toYearTh(year)._0);
                                          })), (function (x) {
                                        return x.label;
                                      })), "-")
                          }) : React.createElement(Form.Select.make, {
                            data: yearOptions,
                            value: String(toYearTh(year)._0),
                            onChange: handleOnChangeYear,
                            disabled: disabled
                          }))));
}

var make = ProfileBirthdate;

export {
  YearTh ,
  YearUs ,
  now ,
  current_us_year ,
  current_month ,
  yearOptions ,
  thmonth ,
  getMonthOptions ,
  daysInMonth ,
  getMaxDay ,
  getDaysOfMonth ,
  getDayOptions ,
  fromISODateString ,
  toISODateString ,
  make ,
  
}
/* now Not a pure module */
